import * as React from "react";
import styled, { css } from "../../../styled/index";
// import { ButtonColors, ButtonSizes } from "../index";
import { Button } from "../index";
const getRoundButtonGroup = css `
  button {
    &:first-child {
      border-top-left-radius: 30px;
      border-bottom-left-radius: 30px;
    }
    &:last-child {
      border-top-right-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
`;
const ButtonGroupComponent = styled("div") `
  display: inline-block;
  white-space: pre;
  button {
    border-radius: 0;
    padding: 0;
    width: ${(props) => props.width === "auto" ? props.width : `${props.width}px`}; 
    &:first-child {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }
    &:last-child {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }
  };
  ${(props) => props.round ? getRoundButtonGroup : ""}
`;
export const ButtonGroup = (props) => (React.createElement(ButtonGroupComponent, { width: props.width, round: props.round, className: props.className, style: props.style }, props.options.map((o, i) => React.createElement(Button, { type: "button", key: i, size: props.size, className: props.buttonClassName || "", color: o.value === props.selected ? "primary" : props.baseColor, onClick: (e) => props.onSelect(o, e) }, o.name))));
//# sourceMappingURL=index.js.map